<template>
  <div
    class="v2-spinner"
    :class="`v2-spinner--${size}`"
  >
    <div class="v2-spinner__circle" />
    <span
      v-if="label"
      class="v2-spinner__label"
    >{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'V2Spinner',
  props: {
    size: { type: String, default: 'md', validator: v => ['sm', 'md', 'lg'].includes(v) },
    label: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.v2-spinner {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: var(--v2-space-2);

  &__circle {
    border: 2px solid var(--v2-border);
    border-top-color: var(--v2-primary);
    border-radius: 50%;
    animation: v2-spin 0.6s linear infinite;
  }

  &--sm .v2-spinner__circle { width: 1rem; height: 1rem; }
  &--md .v2-spinner__circle { width: 1.5rem; height: 1.5rem; }
  &--lg .v2-spinner__circle { width: 2.5rem; height: 2.5rem; }

  &__label { font-size: 0.875rem; color: var(--v2-muted-foreground); }
}

@keyframes v2-spin {
  to { transform: rotate(360deg); }
}
</style>
